/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from "react";
import PropTypes from "prop-types";

import Button from "@shared/v2/Button";
import Dropdown from "@shared/v2/Dropdown";
import { TrashCanSolidV6 } from "@shared/v2/Icomoon";
import RadioButton from "@shared/v2/RadioButton";
import CustomPhoneNumberOption from "./CustomPhoneNumberOption";

import { useContactPerson } from "../../reducers/contactsReducer/selectors";

const SingleValue = ({ children, componentProps }) => {
  const numbersOnly = children.replace(/\D/g, "");
  const countryCodeLength = numbersOnly.length > 10 ? numbersOnly.length - 10 : 0;
  const localNumber = numbersOnly.slice(countryCodeLength);

  let formattedNumber = "";
  if (localNumber.length >= 10) {
    formattedNumber = `(${localNumber.slice(0, 3)}) ${localNumber.slice(3, 6)}-${localNumber.slice(6, 10)}`;
  } else if (localNumber.length >= 6) {
    formattedNumber = `(${localNumber.slice(0, 3)}) ${localNumber.slice(3, 6)}`;
  } else if (localNumber.length >= 3) {
    formattedNumber = `(${localNumber.slice(0, 3)}) ${localNumber.slice(3)}`;
  } else {
    formattedNumber = localNumber;
  }

  return (
    <Dropdown.SingleValue {...componentProps} preserveStyle>
      <div className="tw-flex tw-items-center tw-gap-[8px]">
        {formattedNumber} <span className="tw-capitalize">({componentProps.data.category})</span>
      </div>
    </Dropdown.SingleValue>
  );
};

SingleValue.propTypes = {
  children: PropTypes.node,
  componentProps: PropTypes.shape({}),
};

SingleValue.defaultProps = {
  children: null,
  componentProps: {},
};

const PhoneNumberDropdown = ({
  phoneNumberObj,
  checked,
  onCheck,
  onChange,
  onTrash,
  disabledNumber,
  displayedAs,
}) => {
  const person = useContactPerson();
  const phoneNumbers = person.phoneDetailsAttributes;
  const brivityPhoneNumbers = person.loginUserAttributes?.managedPhoneNumber;

  const options = [
    ...phoneNumbers
      .map((phone) => ({
        label: phone.value,
        value: phone.value,
        category: phone.category,
        id: phone.id || phone.tempId,
        destroy: phone._destroy,
      }))
      .filter((phone) => !phone.destroy),
    ...(brivityPhoneNumbers
      ? [
          {
            label: brivityPhoneNumbers,
            value: brivityPhoneNumbers,
            id: brivityPhoneNumbers,
            category: "Brivity Number",
            destroy: false,
          },
        ]
      : []),
  ];

  useEffect(() => {
    if (phoneNumberObj && !options.find((o) => o.value === phoneNumberObj.phoneNumber)) {
      onChange(null);
    }
  }, [options]);

  return (
    <div className="tw-flex tw-align-center">
      <div className="tw-flex tw-gap-4px tw-w-[352px] tw-mr-auto">
        <Dropdown
          options={options}
          value={options.find((o) => o.value === phoneNumberObj?.phoneNumber) || null}
          containerClassName="tw-flex-1"
          onChange={(o) => onChange({ value: o.value, id: o.id })}
          placeholder="Select a phone number to display"
          components={{
            Option: (props) => <CustomPhoneNumberOption {...props} disabledNumber={disabledNumber} />,
            SingleValue,
            // SingleValue: (props) => <div className="" {...props}>{props.label}</div>,
          }}
        />
        {phoneNumberObj && (
          <Button
            onClick={() => onTrash()}
            schema="tertiary"
            className="tw-w-36px tw-h-36px !tw-rounded-4px !tw-border-1px !tw-border-solid !tw-border-gray-15"
          >
            <TrashCanSolidV6 size="xl" className="tw-text-gray-75" />
          </Button>
        )}
      </div>
      <div className="tw-w-[86px] tw-flex tw-justify-center tw-items-center tw-mr-[24px]">{displayedAs}</div>
      <div className="tw-w-[66px] tw-flex tw-justify-center tw-align-center">
        <RadioButton
          value={phoneNumberObj?.default}
          name="phone_number_user"
          checked={checked}
          disabled={!phoneNumberObj}
          onClick={onCheck}
          labelClassName="tw-hidden"
        />
      </div>
    </div>
  );
};

export default PhoneNumberDropdown;

PhoneNumberDropdown.propTypes = {
  phoneNumberObj: PropTypes.shape({
    value: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    default: PropTypes.bool,
  }),
  checked: PropTypes.bool,
  onCheck: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onTrash: PropTypes.func.isRequired,
  displayedAs: PropTypes.string.isRequired,
  disabledNumber: PropTypes.bool,
};

PhoneNumberDropdown.defaultProps = {
  phoneNumberObj: null,
  checked: false,
  disabledNumber: false,
};
